var map = {
	"./banner-download": [
		"dac5",
		"chunk-2d228e65"
	],
	"./banner-download.json": [
		"dac5",
		"chunk-2d228e65"
	],
	"./banner-slider": [
		"5182",
		"chunk-2d0c778c"
	],
	"./banner-slider.json": [
		"5182",
		"chunk-2d0c778c"
	],
	"./banner-text": [
		"bcd3",
		"chunk-2d21ad46"
	],
	"./banner-text.json": [
		"bcd3",
		"chunk-2d21ad46"
	],
	"./banner-topic": [
		"b62b",
		"chunk-2d20fe7a"
	],
	"./banner-topic.json": [
		"b62b",
		"chunk-2d20fe7a"
	],
	"./blog-news": [
		"99bf",
		"chunk-2d0e6c5a"
	],
	"./blog-news.json": [
		"99bf",
		"chunk-2d0e6c5a"
	],
	"./card-gallery": [
		"a06e",
		"chunk-2d207414"
	],
	"./card-gallery.json": [
		"a06e",
		"chunk-2d207414"
	],
	"./card-text-gallery": [
		"342f",
		"chunk-2d0b998b"
	],
	"./card-text-gallery.json": [
		"342f",
		"chunk-2d0b998b"
	],
	"./category": [
		"36bc",
		"chunk-2d0ba6da"
	],
	"./category.json": [
		"36bc",
		"chunk-2d0ba6da"
	],
	"./department": [
		"a519",
		"chunk-2d208612"
	],
	"./department.json": [
		"a519",
		"chunk-2d208612"
	],
	"./ebook": [
		"4bbc",
		"chunk-2d0cc065"
	],
	"./ebook.json": [
		"4bbc",
		"chunk-2d0cc065"
	],
	"./event": [
		"8088",
		"chunk-2d0dd0ee"
	],
	"./event.json": [
		"8088",
		"chunk-2d0dd0ee"
	],
	"./gallery-picture": [
		"fdf9",
		"chunk-2d2382c7"
	],
	"./gallery-picture.json": [
		"fdf9",
		"chunk-2d2382c7"
	],
	"./html-section": [
		"a5ed",
		"chunk-2d208c89"
	],
	"./html-section.json": [
		"a5ed",
		"chunk-2d208c89"
	],
	"./image-description": [
		"fa10",
		"chunk-2d237110"
	],
	"./image-description.json": [
		"fa10",
		"chunk-2d237110"
	],
	"./lead-form": [
		"7689",
		"chunk-2d0d7316"
	],
	"./lead-form.json": [
		"7689",
		"chunk-2d0d7316"
	],
	"./learning-path": [
		"8b10",
		"chunk-2d0e8bbf"
	],
	"./learning-path.json": [
		"8b10",
		"chunk-2d0e8bbf"
	],
	"./my-online-course": [
		"7d53",
		"chunk-2d0e1f61"
	],
	"./my-online-course.json": [
		"7d53",
		"chunk-2d0e1f61"
	],
	"./offline-course": [
		"5d4c",
		"chunk-2d0d36b4"
	],
	"./offline-course.json": [
		"5d4c",
		"chunk-2d0d36b4"
	],
	"./online-course": [
		"5b35",
		"chunk-2d0d2ee5"
	],
	"./online-course.json": [
		"5b35",
		"chunk-2d0d2ee5"
	],
	"./section-combo": [
		"6467",
		"chunk-2d0cf6f5"
	],
	"./section-combo.json": [
		"6467",
		"chunk-2d0cf6f5"
	],
	"./section-membership": [
		"711f",
		"chunk-2d0d5fa5"
	],
	"./section-membership.json": [
		"711f",
		"chunk-2d0d5fa5"
	],
	"./setting-topic": [
		"605c",
		"chunk-2d0ce7fe"
	],
	"./setting-topic.json": [
		"605c",
		"chunk-2d0ce7fe"
	],
	"./single-image-slider": [
		"e6ca",
		"chunk-2d226185"
	],
	"./single-image-slider.json": [
		"e6ca",
		"chunk-2d226185"
	],
	"./teacher": [
		"0f6b",
		"chunk-2d0af898"
	],
	"./teacher.json": [
		"0f6b",
		"chunk-2d0af898"
	],
	"./testimonial-slider": [
		"a06b",
		"chunk-2d207411"
	],
	"./testimonial-slider.json": [
		"a06b",
		"chunk-2d207411"
	],
	"./text-editor": [
		"c6e9",
		"chunk-2d2178dd"
	],
	"./text-editor.json": [
		"c6e9",
		"chunk-2d2178dd"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7cbf";
module.exports = webpackAsyncContext;